import RoamingZoneCreate from "@/views/AdminPanel/RoamingZoneCreate.vue";
import RoamingZones from "@/views/AdminPanel/RoamingZones.vue";
import RoamingZoneEdit from "@/views/AdminPanel/RoamingZoneEdit.vue";
const routes = [
    {
        path: "/secure/roaming",
        name: "RoamingZones",
        component: RoamingZones,
    },
    {
        path: "/secure/roaming/create",
        name: "RoamingZoneCreate",
        component: RoamingZoneCreate,
    },
    {
        path: "/secure/roaming/edit/:zone_uuid",
        name: "RoamingZoneEdit",
        component: RoamingZoneEdit,
    },
];
export default routes;
